/* eslint-disable react/self-closing-comp */
import { createContext, useContext } from "react";
import TemplatesStore from "./TemplatesStore";
import HistoryStore from "./HistoryStore";
import TemplatesDetailStore from "./TemplatesDetailStore";
import ModerationStore from "./ModerationStore";

export interface IContext {
  TemplatesStore: TemplatesStore;
  HistoryStore: HistoryStore;
  TemplatesDetailStore: TemplatesDetailStore;
  ModerationStore: ModerationStore;
}

export const store: IContext = {
  TemplatesStore: new TemplatesStore(),
  HistoryStore: new HistoryStore(),
  TemplatesDetailStore: new TemplatesDetailStore(),
  ModerationStore: new ModerationStore(),
};

export const StoreContext = createContext(store);
export const useStore = () => useContext(StoreContext);
